<h4 class="ib-heading ib-heading--type-4 ib-summary__section-title ib-summary-item__carbon-heading" [innerHTML]="'IBPURC_PAYMENTS_SUMMARY_CO2_FOOTPRINT_TITLE'|translate">
</h4>
<span class="ib-summary-item__carbon-icon icon-carbon_footprint"></span>
<span class="ib-text ib-text--color-unfocused ib-text--block ib-text--bold ib-summary-item__carbon-title" [innerHTML]="'IBPURC_PAYMENTS_SUMMARY_CO2_FOOTPRINT_KILOS'| translate:{kilosCo2Equivalent: model?.kilosCo2EquivalentFormatted}">
</span>
<div class="ib-list-passengers__item-description">
    <div class="ib-summary-item__carbon-description ib-summary-item__concept ib-summary-item__carbon-amount">
        <span class="ib-text ib-text--block ib-summary-item__carbon-amount" [innerHTML]="'IBPURC_PAYMENTS_SUMMARY_CO2_FOOTPRINT_AMOUNT_TEXT'|translate"></span>
        <span class="ib-text ib-text--block ib-summary-item__carbon-price">{{ model?.totalFormatted }}</span>
    </div>
</div>
